"use strict";
var Observable_1 = require('../../Observable');
var observeOn_1 = require('../../operator/observeOn');
Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
//# sourceMappingURL=observeOn.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/observeOn.js
 ** module id = 471
 ** module chunks = 9
 **/